var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrouphands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 43,
    viewBox: "0 0 53 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 41.5H9.5C6.69974 41.5 5.29961 41.5 4.23005 40.955C3.28924 40.4757 2.52433 39.7108 2.04497 38.77C1.5 37.7004 1.5 36.3003 1.5 33.5V9.5C1.5 6.69974 1.5 5.29961 2.04497 4.23005C2.52433 3.28924 3.28924 2.52433 4.23005 2.04497C5.29961 1.5 6.69974 1.5 9.5 1.5H10.5C16.1005 1.5 18.9008 1.5 21.0399 2.58993C22.9215 3.54867 24.4513 5.07847 25.4101 6.96009C26.5 9.09921 26.5 11.8995 26.5 17.5M26.5 41.5V17.5M26.5 41.5H43.5C46.3003 41.5 47.7004 41.5 48.77 40.955C49.7108 40.4757 50.4757 39.7108 50.955 38.77C51.5 37.7004 51.5 36.3003 51.5 33.5V9.5C51.5 6.69974 51.5 5.29961 50.955 4.23005C50.4757 3.28924 49.7108 2.52433 48.77 2.04497C47.7004 1.5 46.3003 1.5 43.5 1.5H42.5C36.8995 1.5 34.0992 1.5 31.9601 2.58993C30.0785 3.54867 28.5487 5.07847 27.5899 6.96009C26.5 9.09921 26.5 11.8995 26.5 17.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouphands);
export default __webpack_public_path__ + "static/media/grouphands.ae9f573f27b5fefa8d8922f86ec31d4d.svg";
export { ForwardRef as ReactComponent };